import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useRouteError } from "react-router-dom";
import { myCompaniesSelectors } from "../../redux/myCompanies";
import PrivateLayout from "../app/Layout/PrivateLayout";
import PublicLayout from "../app/Layout/PublicLayout";
import { authSelectors } from "../../redux/auth";
import PrivatePage from "../app/Page/PrivatePage";
import NotFoundErrorPage from "./NotFoundErrorPage";
import handleReportError from "./handleReportError";
import InternalServerErrorPage from "./InternalServerErrorPage";
import MaintenanceErrorPage from "./MainteinanceErrorPage";
import NoInternetErrorPage from "./NoInternetErrorPage";
import { errorsTypes } from "../../hooks/useErrorMessage";
import PermissionsErrorPage from "./PermissionsErrorPage";
RouterErrorHandler.propTypes = {};
export default function RouterErrorHandler() {
    var error = useRouteError();
    /**
     * --------------------
     * Get the identity in order to ensure we can link to the dashboard or login
     * --------------------
     */ var hasIdentity = useSelector(authSelectors.hasIdentity);
    var emailIsVerified = useSelector(authSelectors.emailIsVerified);
    var myCompaniesPairs = useSelector(myCompaniesSelectors.myCompaniesPairs);
    /**
     * --------------------
     * Get the translator for the page title
     * --------------------
     */ var t = useTranslation().t;
    /**
     * We want to ensure that we send the error to Sentry & log it on the screen
     */ useEffect(function() {
        handleReportError(error);
    }, []);
    var isMaintenanceError = false;
    var noInternetConnectionError = false;
    var isPermissionsError = false;
    /**
     * We might have a react router response error thrown directly (ex: intlMiddleware) or a standard axios error with
     * response.
     */ if (error.status === 503 || error.response && error.response.status === 503) {
        isMaintenanceError = true;
    }
    if (error.status === 403 || error.response && error.response.status === 403) {
        isPermissionsError = true;
    }
    if (error && error.message === errorsTypes.NO_INTERNET_CONNECTION_ERROR) {
        noInternetConnectionError = true;
    }
    /**
     * If the status is 426 it means that the user is using an outdated app version so we refresh the page
     */ if (error.status === 426 || error.response && error.response.status === 426) {
        window.location.reload();
    }
    if (error.status === 404 || error.response && error.response.status === 404) {
        // It needs an embedded layout because it might also be returned by the router when no route is matched,
        // and needs to render the correct layout depending on whether the user has identity or not.
        // If the user has an identity we want to display this page in a private layout, else in a public layout
        //! -> would duplicate the layout if moved below in some cases (ex: Getting 404 errors from apis)
        return /*#__PURE__*/ React.createElement(NotFoundErrorPage, null);
    }
    var Layout = hasIdentity && emailIsVerified && myCompaniesPairs.length > 0 ? PrivateLayout : PublicLayout;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(PrivatePage, {
        title: isMaintenanceError ? t("common.errors.pages.maintenance.title") : noInternetConnectionError ? t("common.errors.pages.no-internet.title") : t("common.errors.pages.internal-server-error.title")
    }, isMaintenanceError && /*#__PURE__*/ React.createElement(MaintenanceErrorPage, null), isPermissionsError && /*#__PURE__*/ React.createElement(PermissionsErrorPage, null), noInternetConnectionError && /*#__PURE__*/ React.createElement(NoInternetErrorPage, null), !isMaintenanceError && !noInternetConnectionError && !isPermissionsError && /*#__PURE__*/ React.createElement(InternalServerErrorPage, {
        hasIdentity: hasIdentity && emailIsVerified ? true : false
    })));
}
